import { render, staticRenderFns } from "./WorkExperienceForm.vue?vue&type=template&id=2b0e7ba4&scoped=true&"
import script from "./WorkExperienceForm.vue?vue&type=script&lang=ts&"
export * from "./WorkExperienceForm.vue?vue&type=script&lang=ts&"
import style0 from "./WorkExperienceForm.vue?vue&type=style&index=0&id=2b0e7ba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e7ba4",
  null
  
)

export default component.exports